<template>
  <div class="v-summary">
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="4" lg="3" xl="2">
          <ProjectsList
            :simple="true"
            multiple
            :persistKey="persistKey"
            @reset="onReset"
          />
        </v-col>
        <v-col cols="12" md="8" lg="9" xl="10" v-if="selectedProject">
          <SummaryByProject
            :projectId="selectedProject"
            :key="selectedProject.toString() + '-' + summaryResetKey"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { VIEW_KEYS } from '@/utils/viewStatePersistence'

export default {
  name: 'Summary',
  components: {
    ProjectsList: () => import('@/components/tasks_editor/ProjectsList.vue'),
    SummaryByProject: () => import('@/components/summary/SummaryByProject.vue')
  },
  data () {
    return {
      persistKey: VIEW_KEYS.summary,
      summaryResetKey: 0
    }
  },
  computed: {
    selectedProject () {
      return this.$store.getters.getSelectedProject
    }
  },
  methods: {
    onReset () {
      this.summaryResetKey += 1
    }
  }
}
</script>
